/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import { Distribution, DistributionFromJSON, DistributionFromJSONTyped, DistributionToJSON } from './Distribution'

/**
 *
 * @export
 * @interface AffiliateDistributionRequest
 */
export interface AffiliateDistributionRequest {
  /**
   *
   * @type {Distribution}
   * @memberof AffiliateDistributionRequest
   */
  distribution?: Distribution
}

export function AffiliateDistributionRequestFromJSON(json: any): AffiliateDistributionRequest {
  return AffiliateDistributionRequestFromJSONTyped(json, false)
}

export function AffiliateDistributionRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AffiliateDistributionRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    distribution: !exists(json, 'distribution') ? undefined : DistributionFromJSON(json['distribution']),
  }
}

export function AffiliateDistributionRequestToJSON(value?: AffiliateDistributionRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    distribution: DistributionToJSON(value.distribution),
  }
}
